<template>
  <div class="matter-page-list">
    <v-list :two-line="true">
      <v-list-item-group>
        <v-list-item
          :ripple="false"
          active-class="matter-page-list-item-active"
          class="matter-page-list-item" :class="{'item-seperator': seperator}"
          v-for="item in list"
          :key="item.uid">
          <slot name="list-prview" v-bind:item="item" />
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "MatterPageList",
  props: {
    list: {
      type: Array,
      required: true
    },
    seperator: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.matter-page-list {

  .matter-page-list-item-active::before {
    opacity: 0;
  }

  .matter-page-list-item {
    padding: 10px 0;

    &::before {
      background-color: transparent
    }

    &:hover::before {
      opacity: 0;
    }

    &.item-seperator:not(:last-child) {
      border-bottom: 1px solid $dividerColor;
    }
  }
}
</style>
